import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';

export const QuestionInfo = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  padding: ${({ preview }) => (preview ? '15px 24px 42px' : '15px 24px 54px')};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};
  background-color: ${({ theme }) => theme.mainColor};
  ${fontSmoothing}
  color: #fff;
  text-align: left;

  p {
    padding-top: 6px;
    font-weight: 600;
  }
`;
